import * as React from 'react';
import { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

import { AuthContext } from "../../context/Auth/AuthContext";


const VcardPreview = ({ contact, numbers, originalVCard }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);
    const [errorOccurred, setErrorOccurred] = useState(false);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async() => {
                try {
                    if (numbers === "No number found") {
                        console.error('No valid number found');  // Log the error but don't throw
                        setErrorOccurred(true);
                        return;
                    }
                    let contactObj = {
                        name: contact,
                        number: numbers.replace(/\D/g, ""),
                        email: "",
                        quotation: ""
                    }
                    const { data } = await api.post("/contact", contactObj);
                    setContact(data)

                } catch (err) {
                    if (err.response && err.response.status === 404) {
                        console.warn('Resource not found');  // Just log a warning
                    } else {
                        console.error(err);  // Log other errors
                    }
                    setErrorOccurred(true);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    const handleNewChat = async() => {
        try {
            const { data: ticket } = await api.post("/chats", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
            });
            history.push(`/chats/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    }

   if (errorOccurred) {
        return <div>{originalVCard}</div>;
    }

    return (
		<>
			<div style={{
				minWidth: "250px",
			}}>
				<Grid container spacing={1}>
					<Grid item xs={2}>
						<Avatar src={selectedContact.profilePicUrl} />
					</Grid>
					<Grid item xs={9}>
						<Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
							{selectedContact.name}
						</Typography>
                        <Typography style={{ marginLeft: "10px" }} variant="body1" color="textSecondary">
                            {selectedContact.number}
                        </Typography>
					</Grid>
					<Grid item xs={12}>
						<Divider />
						<Button
							fullWidth
							color="primary"
							onClick={handleNewChat}
							disabled={!selectedContact.number}
						>Click To Chat</Button>
					</Grid>
				</Grid>
			</div>
		</>
	);

};

export default VcardPreview;